import React from 'react'
import CancelPageView from 'src/pages/CancelPage/view'
import { cancelQueryOption, useCustomMutation } from 'src/hooks/react-query/useCustomMutation.hook'
import { useModal } from 'src/provider/ModalContextProvider'
import { CancelSpace, ResponseDataType } from 'src/types/api'
import { ERRCODE_SUCCESS } from 'src/service/constant/errcodes'
import usePageNav from 'src/hooks/usePageNav.hook'
import useCustomCookies from 'src/hooks/useCustomCookies.hook'
import RenderIf from 'src/components/common/RenderIf'
import { Loading } from 'src/components/common/Loading'
import { addFlowBreadcrumb } from 'src/utils/sentry/breadcrumbs'

export interface CancelPageProps {
  cancelHandler: () => void
  isCancelSubmitPending: boolean
}

const CancelPage = () => {
  const { cancelCompletePageNav, introPageNav } = usePageNav()
  const { removeAllCookies } = useCustomCookies()
  const { openModal } = useModal()

  const { mutateAsync: cancelMutate, isPending: isCancelSubmitPending } = useCustomMutation<
    CancelSpace.Request,
    CancelSpace.Response
  >(cancelQueryOption())

  const cancelSubmit = () => {
    addFlowBreadcrumb('cancel_attempt', 'request', { handler: 'cancelSubmit' })
    cancelMutate({})?.then((res: ResponseDataType<CancelSpace.Response>) => {
      const { ErrCode } = res?.Header
      if (ErrCode === ERRCODE_SUCCESS) {
        localStorage.clear()
        removeAllCookies()
        introPageNav()
        cancelCompletePageNav()
      } else {
        addFlowBreadcrumb('cancel_fail', 'response', { handler: 'cancelSubmit', errCode: ErrCode })
      }
    })
  }

  const cancelHandler = () => {
    addFlowBreadcrumb('cancel_attempt', 'request', { handler: 'cancelHandler' })
    const t = '서비스 해지'
    const d = '1개월 내 재가입 및 구매내역 복원이 불가능합니다. 해지하시겠습니까?'
    openModal({
      contents: { t, d },
      button: { submit: { t: '확인', f: cancelSubmit }, cancel: { t: '취소' } },
    })
  }

  const props: CancelPageProps = {
    cancelHandler,
    isCancelSubmitPending,
  }

  return (
    <React.Fragment>
      <RenderIf when={isCancelSubmitPending}>
        <Loading.Default />
      </RenderIf>
      <CancelPageView {...props} />
    </React.Fragment>
  )
}
export default CancelPage
